import { d as deepMerge } from './deep-merge-c6cfd18c.js';

const createThemeBreakpoints = breakpointsInput => {
  if (Array.isArray(breakpointsInput)) {
    return [...[`${499}px`, `${768}px`, `${992}px`, `${1200}px`], ...breakpointsInput];
  }
  return deepMerge({
    xs: 499,
    sm: 768,
    md: 992,
    lg: 1200
  }, breakpointsInput);
};

export { createThemeBreakpoints };
